/**
 * @author        mike.zarra@zumper.com (Mike Zarra)
 * @copyright     Copyright (c) 2021, Zumper
 * @description   checks if url is an allowed host – defaults to URL.hostname
 */

import { logger } from './logger'

export const isSanitizedUrl = (url: string, allowedHosts?: string[]) => {
  // https://developer.mozilla.org/en-US/docs/Web/API/URL
  if (!url || !allowedHosts?.length) return false

  try {
    const inputUrl = new URL(url)?.hostname
    return allowedHosts?.includes(inputUrl)
  } catch (e) {
    logger.warn(
      `Failed to sanitize URL: ${url} - allowedHosts: [${String(
        allowedHosts
      )}]`,
      e
    )
  }
  return false
}
